import { useContext, useState } from "react";
import Input from "../Input";
import { MultiContext } from "../../Context";
import Button from "../Button";

export default function NewAccount({ className = "" }) {
  const multiCtx = useContext(MultiContext);

  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [url, setUrl] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [notes, setNotes] = useState("");

  const onChangeName = (e) => setName(e.target.value);
  const onChangeUsername = (e) => setUsername(e.target.value);
  const onChangePassword = (e) => setPassword(e.target.value);
  const onChangeUrl = (e) => setUrl(e.target.value);
  const onChangeThumbnail = (e) => setThumbnail(e.target.value);
  const onChangeNotes = (e) => setNotes(e.target.value);

  const [charLimit, setCharLimit] = useState(8);
  const onChangeCharLimit = (e) => setCharLimit(e.target.value);

  const [copied, setCopied] = useState(false);

  const generate = () => {
    // multiCtx.setLoading(true);
    // api("generate", { charLimit: charLimit }, (data) => {
    //   multiCtx.setLoading(false);
    //   setPassword(data.password);
    // });
  };

  const copy = () => {
    navigator.clipboard.writeText(password);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  return (
    <div className={className + ""}>
      <form
        onSubmit={(e) => {
          multiCtx.addAccount(
            e,
            name,
            username,
            password,
            url,
            thumbnail,
            notes
          );
          setName("");
          setUsername("");
          setPassword("");
          setUrl("");
          setThumbnail("");
          setNotes("");
        }}
        className="">
        <div className="mb-3">
          <div className="small fw-bold">Name</div>
          <Input required={true} value={name} onChange={onChangeName} />
        </div>
        <div className="mb-3">
          <div className="small fw-bold">Username</div>
          <Input value={username} onChange={onChangeUsername} />
        </div>

        <div className="input-group py-3">
          <input
            min={8}
            max={60}
            value={charLimit}
            onChange={onChangeCharLimit}
            className="form-control form-control-sm"
            type="number"
          />
          <Button
            onClick={() => generate()}
            text="Generate"
            icon="arrow-right"
          />
          <Input
            required={true}
            className="w-50"
            onChange={onChangePassword}
            placeholder="Pas$$w0rd!"
            value={password}
          />
          {password !== "" && (
            <Button
              onClick={() => copy()}
              icon={copied ? "check-lg" : "copy"}
            />
          )}
        </div>

        <div className="mb-3">
          <div className="small fw-bold">URL</div>
          <Input value={url} onChange={onChangeUrl} />
        </div>
        <div className="mb-3">
          <div className="small fw-bold">Thumbnail URL</div>
          <Input value={thumbnail} onChange={onChangeThumbnail} />
        </div>
        <div className="mb-3">
          <div className="small fw-bold">Notes</div>
          <textarea
            className="form-control  form-control-sm"
            autoComplete="off"
            rows={5}
            value={notes}
            onChange={onChangeNotes}></textarea>
        </div>
        <Button className="w-100" type_="submit" text="Add" icon="plus-lg" />
      </form>
    </div>
  );
}
